import {
  SearchDropdownType,
  SearchFieldElement,
} from "@/app/layouts/standard/header/search-bar/search-bar-dropdown/searchFieldDropdown";
import { SearchFieldDropdownElement } from "@/app/layouts/standard/header/search-bar/search-bar-dropdown/searchFieldDropdownElement";
import { SearchSuggestionsResponse } from "@/fetch/algolia/getSearchSuggestions";
import { DeviceType } from "@/types/search";
import { useWindowWidth } from "@react-hook/window-size";
import { useMemo } from "react";
import styles from "./searchFieldDropdown.module.scss";

export const SearchSuggestionsDropdown = ({
  searchSuggestionsResponse,
  dropdownItemChooseCallback,
  reportClosedCallback,
}: SearchFieldDropdownProps) => {
  const windowWidth = useWindowWidth();
  const deviceType: DeviceType = useMemo(() => {
    if (windowWidth < 564) return "mobile";
    else if (windowWidth < 992) return "tablet";
    return "desktop";
  }, [windowWidth]);
  return (
    <div className={styles["dropdownContentContainer"]}>
      {searchSuggestionsResponse?.textSearchSuggestions
        .slice(0, deviceType === "mobile" ? MAX_SEARCH_SUGGESTIONS_MOBILE : MAX_SEARCH_SUGGESTIONS)
        .map((suggestion, index) => {
          let startIndex = -1;
          let endIndex = -1;
          let prefix;
          let boldQuery = searchSuggestionsResponse.inputQuery;
          let suffix;
          if (suggestion.query && searchSuggestionsResponse.inputQuery) {
            startIndex = suggestion.query.indexOf(searchSuggestionsResponse.inputQuery);
            endIndex = startIndex + searchSuggestionsResponse.inputQuery.length;
            prefix = suggestion.query.substring(0, startIndex);
            boldQuery = suggestion.query.substring(startIndex, endIndex);
            suffix = suggestion.query.substring(endIndex);
          }
          const item: SearchFieldElement = {
            dropdownType: SearchDropdownType.SEARCH_SUGGESTIONS,
            label: suggestion.query,
            id: String(index),
            prefix: prefix,
            unboldedQuery: boldQuery,
            suffix: suffix,
          };
          return (
            <SearchFieldDropdownElement
              key={index}
              elementDetails={item}
              dropdownItemChooseCallback={dropdownItemChooseCallback}
            />
          );
        })}
    </div>
  );
};

type SearchFieldDropdownProps = {
  searchSuggestionsResponse: SearchSuggestionsResponse | undefined | null;
  dropdownItemChooseCallback: (elementDetails: SearchFieldElement) => void;
  reportClosedCallback: (dropdownType: SearchDropdownType) => void;
};

export const MAX_SEARCH_SUGGESTIONS = 10;
export const MAX_SEARCH_SUGGESTIONS_MOBILE = 6;
